var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import LatestCatalogObject from '@square/dashboard-items-data/adapters/connect/latest-catalog-object';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { MULTIPLE_IMAGES_API_VERSION as SUBSCRIPTION_PLAN_API_VERSION } from '@square/dashboard-items-data/adapters/connect/image';
import { SUBSCRIPTION_ITEMIZATION_API_VERSION } from '@square/dashboard-items-data/models/connect/subscription-plan';
import { isNone } from '@ember/utils';
import { CatalogQuery, CatalogQuerySet, CatalogQueryRange, CatalogSortedAttributeQuery } from '@square/dashboard-items-data/clients/catalog-connect-v2';

// Remove async itemization status ASAP
let SubscriptionPlan = (_dec = service('buyer-subs/itemization-status'), _dec2 = computed('itemizationStatus.isItemized'), _class = class SubscriptionPlan extends LatestCatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "itemizationStatus", _descriptor2, this);
  }
  shouldBackgroundReloadRecord(store, snapshot) {
    return snapshot?.id?.[0] !== '#';
  }
  get headers() {
    if (this.itemizationStatus.isItemized || this.features.isEnabled('buyersubs/updated_legacy_api_version')) {
      return {
        'Square-Version': SUBSCRIPTION_ITEMIZATION_API_VERSION
      };
    } else {
      return {
        'Square-Version': SUBSCRIPTION_PLAN_API_VERSION
      };
    }
  }
  query(store, type, query) {
    const adapterOptions = query.adapterOptions || {};
    const queryObj = {};
    if (isNone(query.adapterOptions)) {
      return super.query(store, type, query, {
        headers: this.headers
      });
    }
    if (!isNone(query.adapterOptions?.itemIds)) {
      queryObj.setQuery = CatalogQuerySet.create({
        attributeName: 'item_id',
        attributeValues: query.adapterOptions.itemIds
      });
    } else if (query.adapterOptions.allItems) {
      queryObj.rangeQuery = CatalogQueryRange.create({
        attributeName: 'all_items',
        attributeMinValue: 1,
        attributeMaxValue: 1
      });
    }
    if (adapterOptions.sort) {
      queryObj.sortedAttributeQuery = CatalogSortedAttributeQuery.create({
        attributeName: adapterOptions.sort.sortKey
      });
    }
    if (Object.keys(queryObj).length > 0) {
      query.query = CatalogQuery.create(queryObj);
    }
    if (query.adapterOptions.limit) {
      query.limit = query.adapterOptions.limit;
    }
    delete query.adapterOptions;
    return super.query(store, type, query, {
      headers: this.headers
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "itemizationStatus", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "headers", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "headers"), _class.prototype), _class);
export { SubscriptionPlan as default };